import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'standard' },
    { value: 2, label: 'eightymm' },
  ],
});
